<!-- Ported from the Polaris kit: src/components/ui/field/FieldTitle.vue.
     Classes translated to Tailwind 3 by rebranding_frontend/port-kit-component.mjs.
     Change the design in the kit first, then re-port. -->
<script setup>
import { cn } from '../../lib/utils';

const props = defineProps({
  class: {
    type: [Boolean, null, String, Object, Array],
    required: false,
    skipCheck: true,
  },
});
</script>

<template>
  <div
    data-slot="field-label"
    :class="
      cn(
        'type-polaris-label flex w-fit items-center gap-2 group-data-[disabled=true]/field:opacity-50',
        props.class
      )
    "
  >
    <slot />
  </div>
</template>
